<template>

  <Teaser
    v-if="false"
    alt="Hair – Musical"
    :desktop="{ url: '/media/WbdH_2000x600.jpg', width: 2000, height: 600, style: { objectPosition: '50% 50%' }}"
    :mobile="{ url: '/media/WbdH_1436x867.jpg', width: 1436, height: 867 }"
  >
    <div class="md:text-lg mb-2 md:mb-4">
      Komödie, Wiederaufnahme
    </div>
    <h1 class="text-4xl md:text-4xl font-bold mb-2 md:mb-4" style="line-height: 1.1">
      Willkommen bei den Hartmanns
    </h1>
    <p class="text-lg md:text-2xl text-blue-500 mb-6 md:mb-8">
      <!-- Vorverkauf gestartet! -->
      <!-- Vorverkauf für Abonnent*innen und Förderkreismitglieder gestartet! -->
      <!-- Vorverkauf für DAS DA-Card-Inhaber*innen und Förderkreismitglieder gestartet! -->
      <!-- Nur noch wenige Karten verfügbar! -->
      <!-- Nur wenige Termine verfügbar! -->
      <!-- ab dem 13.11. am DAS DA -->
      <!-- Vorverkauf für Abonnent*innen, Förderkreismitglieder und DAS DA-Card-Inhaber*innen gestartet! -->
      <!-- Offizieller Vorverkauf gestartet! -->
      <!-- Freier Vorverkauf gestartet! -->
    </p>
    <Link
      :href="route('events.show', ['willkommen-bei-den-hartmanns'])"
      class="button py-3"
      text="Jetzt Tickets sichern"
    />
  </Teaser>

  <!-- <Teaser
    v-if="false"
    alt="Hair – Musical"
    :desktop="{ url: '/media/Sonnenallee_desktop.jpg', width: 2000, height: 600, style: { objectPosition: '65% 50%' }}"
    :mobile="{ url: '/media/Sonnenallee_mobile.jpg', width: 1436, height: 974 }"
  >
    <h1 class="text-4xl md:text-4xl font-bold mb-2 md:mb-4" style="line-height: 1.1">
      DAS DA-Abo
    </h1>
    <p class="text-lg md:text-2xl text-blue-500 mb-6 md:mb-8">
      Sparen Sie beim Kauf eines Abos und nutzen Sie zusätzlich die exklusive Vorverkaufszeit
    </p>
    <Link
      :href="route('coupons.index')"
      class="button py-3"
      text="Jetzt Abo kaufen"
    />
  </Teaser> -->

  <div class="pt-24 container">
    <BuyCoupon />
  </div>

  <!-- <div class="pt-24 container">
    <UpcomingCoupon />
  </div> -->

  <div class="py-24 container">
    <EventsGrid :events="events" />
  </div>

</template>

<script>
import Layout from 'Web/Layouts/WithCart.vue';
import BuyCoupon from 'Web/Shared/BuyCoupon.vue';
import UpcomingCoupon from 'Web/Shared/UpcomingCoupon.vue';
import EventsGrid from 'Web/Shared/EventsGrid.vue';
import Teaser from 'Web/Shared/Teaser.vue';
import Link from 'Web/Shared/Link.vue';
import useMeta from '@/compose/meta';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    EventsGrid,
    Teaser,
    Link,
    BuyCoupon,
    UpcomingCoupon,
},
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { assign } = useMeta();

    assign({ title: 'DAS DA-Onlineshop' });
  }
}
</script>
